<template>
  <div class="text-center" style="margin-bottom: -20px">
    <h2 >{{ $t( 'home.vacancyCount' ) }}:

      <b-badge variant="primary">{{ total }}</b-badge>
    </h2>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState( 'ennounsment', {'ennounsmentlist': 'list', 'total': 'total'}
    ),
  },
  methods: {
    // ...mapState(["jobs"])
  }

}
</script>
